import { GET_DUGOUT_ACTIVE_PROGRAM_FAMILIES_QUERY_KEY } from '@/constants/programs';
import useAPI from '@/hooks/useAPI';
import DugoutProgramFamilyRepository from '@/repositories/DugoutProgramFamilyRepository';

export const useDugoutActiveProgramFamilies = () => {
  const repository = DugoutProgramFamilyRepository();

  return useAPI({
    queryKey: [GET_DUGOUT_ACTIVE_PROGRAM_FAMILIES_QUERY_KEY],
    queryFn: async () => await repository.listActive(),
    staleTime: Infinity
  });
};

export default useDugoutActiveProgramFamilies;
